import {ApplicationStoreType} from 'reducers';
import {ContactsPdpType} from 'features/contacts/constants/types';
import {MonthlyPaymentsType} from 'constants/flow/flowTypesCart';

/**
 * Returns contacts pdp fields
 * @param {ApplicationStoreType} store - store
 * @return {ContactLensPrescription} - fields from wizard
 */
export const getContactsPdp = (store: ApplicationStoreType): ContactsPdpType => store.contactsPdp;

/**
 * Returns monthly payments
 * @param {ApplicationStoreType} store - store
 * @return {MonthlyPaymentsType} - monthly payments
 */
export const getMonthlyPayments = (store: ApplicationStoreType): MonthlyPaymentsType =>
    store.monthlyPayments;
